import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, HeartHandshake, Sparkles } from "lucide-react";

export default function About() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative py-32 md:py-40 px-6 md:px-10 overflow-hidden">
        <div className="absolute inset-0 pattern-girih opacity-30" />
        <div className="relative max-w-5xl mx-auto text-center">
          <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Our Story</div>
          <h1 className="display text-5xl md:text-7xl mt-4 text-ink">
            A <em className="text-emerald_deep">sanctuary</em> for the Flint Muslim community.
          </h1>
          <p className="mt-8 text-lg md:text-xl text-ink/70 font-light leading-relaxed max-w-3xl mx-auto">
            For over three decades, Flint Islamic Center has been a place of worship, learning, and
            service — rooted in the teachings of the Prophet Muhammad ﷺ.
          </p>
        </div>
      </section>

      {/* Mission / Vision */}
      <section className="px-6 md:px-10 pb-24">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">
          <div className="rounded-3xl bg-white border border-sand p-10 md:p-12">
            <div className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">Mission</div>
            <h2 className="font-serif text-3xl mt-3 text-ink">What we stand for</h2>
            <p className="mt-5 text-ink/70 leading-relaxed font-light">
              {settings?.about_mission}
            </p>
          </div>
          <div className="rounded-3xl bg-emerald_deep text-cream p-10 md:p-12 relative overflow-hidden">
            <div className="absolute inset-0 pattern-girih opacity-25" />
            <div className="relative">
              <div className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">Vision</div>
              <h2 className="font-serif text-3xl mt-3 text-cream">Where we're going</h2>
              <p className="mt-5 text-cream/80 leading-relaxed font-light">
                {settings?.about_vision}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values grid */}
      <section className="py-24 bg-sand/40 px-6 md:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Our Values</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-3 text-ink">Unity · Compassion · Community</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { Icon: Users, t: "Unity", d: "Bringing together Muslims of every background into one worshipping family." },
              { Icon: HeartHandshake, t: "Compassion", d: "Care for the sick, support for the grieving, uplift for the forgotten." },
              { Icon: Sparkles, t: "Community", d: "Education, dialogue, and service that strengthens Flint as a whole." },
            ].map((v) => (
              <div key={v.t} className="rounded-3xl bg-white border border-sand p-10">
                <div className="w-14 h-14 rounded-2xl bg-navy/5 text-navy flex items-center justify-center mb-5">
                  <v.Icon size={22} className="text-gold" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl text-ink">{v.t}</h3>
                <p className="mt-3 text-ink/65 leading-relaxed text-sm">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
